import makeRequest from "./makeRequest";
import { GET } from "../constants";
import getConstants from "../runtimeConstants";
import getConfig from "../config";

export async function getSizeGuideData(sizeGuideId) {
  const language = getConstants().webContext.browseLanguage;
  const { sizeGuideApiUrl, sizeGuideApiTimeout } = getConfig();

  let url = `${sizeGuideApiUrl}/${sizeGuideId}?language=${language}`;

  return await makeRequest({
    url,
    method: GET,
    apiName: "Size Guide",
    caller: "Size Guide",
    timeout: sizeGuideApiTimeout,
  });
}
